import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import { DatePickerInput } from "rc-datepicker";
import 'rc-datepicker/lib/style.css';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import ApproveExpense from "./ApproveExpense";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Session from "react-session-api";

const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

const SeniorExpenseApproval = () => {
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [isOpen, setOpen] = useState(false);
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [Status, setStatus] = useState('');
    const [response, fetchData] = UseFetchData();
    const [shoppingItems1, setShoppingItems] = useState([]);

    const Statuscmb = [
        { id: "TR Approved", title: "TR Approved" },
        { id: "TR Rejected", title: "TR Rejected" },
        { id: "Travelling", title: "Travelling" },
        { id: "Exp Approved", title: "Exp Approved" },
        { id: "Exp Rejected", title: "Exp Rejected" },
        { id: "SR Approved", title: "SR Approved" }, // Added Senior Approval status
        { id: "SR Rejected", title: "SR Rejected" }, // Added Senior Rejection status
        { id: "ACC Approved", title: "ACC Approved" },
        { id: "ACC Paid", title: "ACC Paid" },
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['TravelRequestNo', 'TravelRequestDate', 'EmpCode', 'EmpName', 'Locationto']
                }} />
            </GridToolbarContainer>
        );
    }

    const PopulateData = () => {
        var bodyFormData = new FormData();
        
        bodyFormData.append("TravelRequestID", "");
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("CategoryID", Session.get("CategoryID"));
        bodyFormData.append("UserType", Session.get("UserType"));
        bodyFormData.append("PageName", 'SeniorExpenseList'); 
        fetchData("ExpMangt/TravelRequestListWeb", bodyFormData)
      
    };

    useEffect(() => {
        debugger;
        console.log("responseeeeee: ", response);
        if (Array.isArray(response)) {
            
            const userType = Session.get("UserType");
            // Filter for expenses that need senior approval
           /* let filteredItems = response.filter(item => 
                item.ApprovalStatus === "Exp Approved" 
            );*/
            let filteredItems = response;

            const newShoppingItems = filteredItems.map((item) => ({
                id: item.TravelRequestID,
                No: item.TravelRequestNo,
                EmpName: item.EmpName,
                Status: item.ApprovalStatus,
                FromDate: item.FromDate,
                ToDate: item.ToDate,
                TravelFrom: item.LocationFromTravel,
                TravelTo: item.LocationToTravel,
                Purpose: item.PurposeOfTravel,
                Amt: item.ApproxExpAmount,
                TotalExAmt: item.TotalExpenseAmount,
                NoOfExpense: item.NoofExp
            }));

            setShoppingItems(newShoppingItems);
        }
    }, [response]);

    useEffect(() => {
        PopulateData();
    }, [])

    return (
        <div>
            <Paper elevation={0}>
                <Grid container spacing={2}>
                    {
                        Session.get("UserType") === "Manager" &&
                        shoppingItems1.map((item) => (
                            <Grid key={item.id} item xs={12} sm={12} md={4} lg={4}>
                                <Card style={{ border: '1px solid #e0e0e0' }}>
                                    <CardContent>
                                        <b>TR.No : </b>{item.No}
                                        <span style={{ marginLeft: '20px' }}></span>
                                        <b>Status: </b>
                                        <span style={{ 
                                            fontWeight: 'bold', 
                                            color: item.Status === 'Manager Approved' ? '#00903D' : 
                                                   item.Status === 'Manager Rejected' ? '#FF0000' : '#001B71' 
                                        }}>
                                            {item.Status}
                                        </span>
                                        <Typography variant="body2" marginTop={1}>
                                            <b>Employee Name : </b> {item.EmpName}
                                        </Typography>
                                        <Typography variant="body2" marginTop={1}>
                                            <b>From Date : </b> {item.FromDate != null ? moment(item.FromDate).format("DD/MMM/YYYY") : ""}
                                            <span style={{ marginLeft: '20px' }}></span>
                                            <b>To Date: </b> {item.ToDate != null ? moment(item.ToDate).format("DD/MMM/YYYY") : ""}
                                        </Typography>
                                        <Typography variant="body2" marginTop={1}>
                                            <b>Travel From : </b> {item.TravelFrom}
                                            <span style={{ marginLeft: '20px' }}></span>
                                            <b>Travel To : </b> {item.TravelTo}
                                        </Typography>
                                        <Typography variant="body2" marginTop={1}>
                                            <b>Purpose of Travel : </b> {item.Purpose}
                                        </Typography>
                                        <Typography variant="body2" marginTop={1}>
                                            <b>Approx Amt : </b> {item.Amt}
                                            <span style={{ marginLeft: '20px' }}></span>
                                            <b>Total Exp Amt : </b> {item.TotalExAmt}
                                            <span style={{ marginLeft: '20px' }}></span>
                                            <b>No of Exp :</b> {item.NoOfExpense}
                                        </Typography>
                                        <BiztranControls.Button
                                            text="View"
                                            onClick={() => {
                                                setOpen(true);
                                                setTravelRequestID(item.id)
                                            }}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    }
                </Grid>

                <Modal_Frame
                    title="Senior Expense Approval"
                    maxWidth="sm"
                    isOpen={isOpen}
                    setOpen={setOpen}
                >
                    <ApproveExpense
                        TravelRequestID={TravelRequestID}
                        setOpen={setOpen}
                        PopulateData={PopulateData}
                        userType={Session.get("UserType")}
                        isSeniorApproval={true} // New prop to indicate senior approval
                        isManagerApproval={true} // For manager approval
                    />
                </Modal_Frame>
            </Paper>
        </div>
    )
}

export default SeniorExpenseApproval;
